import { render, staticRenderFns } from "./ModalEndorsementExample.vue?vue&type=template&id=08075588&"
import script from "./ModalEndorsementExample.vue?vue&type=script&lang=js&"
export * from "./ModalEndorsementExample.vue?vue&type=script&lang=js&"
import style0 from "./ModalEndorsementExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports